import React from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import Order from '@components/order/models/list/Order';
import { Stack } from '@mui/system';
import { CheckingStatusIcon, ConfirmedStatusIcon, DeniedStatusIcon } from '@components/order/components/common/OrderStatusIcons';

interface OrderLiveStatusIconProps {
    order: Order;
}

const OrderLiveStatusIcon: React.FC<OrderLiveStatusIconProps> = observer(({ order }) => {
    if (order.isConfirmed === undefined || order.isConfirmed === null) {
        return (
            <Stack sx={{
                animation: "spin 2.6s linear infinite",
                "@keyframes spin": {
                    "0%": {
                        transform: "rotate(0deg)",
                    },
                    "100%": {
                        transform: "rotate(360deg)",
                    },
                },
            }}>
                <CheckingStatusIcon height={200} width={228} />
            </Stack>
        )
    }
    else if (order.isConfirmed) {
        return <ConfirmedStatusIcon height={200} width={228} />
    }
    else if (order.isConfirmed === false){
        return <DeniedStatusIcon height={200} width={228} />
    }
})

export default OrderLiveStatusIcon;